<template>
    <div>
      <!-- Content -->
      <div class="container mt-6 px-5" style="margin-bottom: 5rem" >
        <div class="is-clickable column mr-2 is-flex colour-secondary-01 is-underlined bold-l2 my-5 pl-0" @click="$router.push('/consultant/my-resource-centre')">
            <b-icon
                icon="menu-left"
                custom-size="is-large"
                style="font-size: 30px;"
            ></b-icon>
          <span>Back to My Resource Centre</span>
        </div>
        <div class="columns is-12 is-mobile is-desktop is-multiline">
          <div class="column is-5-desktop is-12-mobile">
            <figure class="image is-square">
              <img :src="image ? image : require('@/assets/img/default_photo_big.jpg') " />
            </figure>
          </div>
          <div class="column is-7-desktop is-12-mobile has-text-left pl-5">
            <div class="colour-primary-02 bold-l">Guide Details</div>
            <div class="pb-title">{{ title }}</div>
            <div class="" v-html="content" />
            <b-button 
              class="button dark-red mt-4" 
              icon-right="download" style="color:white"
              @click="downloadForm(link)"
              :disabled="!link"
              >
              <p class="download">Download Slides</p>
            </b-button>
          </div>
        </div>

      </div>
  
      
    </div>
  </template>
  
  <script>
    import dayjs from 'dayjs';
    import Axios from 'axios'
  
    export default {
      data() {
        return {
          title: '',
          content: '',
          link: '',
          image: null,
          training: []
        };
      },
      mounted() {
        window.scrollTo(0, 0);
        this.$httpClientCMS({
          method: 'GET',
          url:'api/my-resource-centres?populate=*&filters[category]=Guide&filters[id]=' + this.$route.params.id,
        })
        .then(resp =>{
          let totalArr = resp.data.data[0]
          this.training = totalArr
          this.content = totalArr.attributes.content;
          this.link  = totalArr.attributes.link
          this.title = totalArr.attributes.title
          this.image = totalArr.attributes.image.data.attributes.url
        })
      },
      computed: {
    
      },
      methods:{
        downloadForm(link) {
          window.open(link)
        },
      }
    }
  </script>
  
  <style scoped lang="scss">
  
  :deep(){

    
    @media screen and (max-width: 1023px){

    }
  
    @media screen and (max-width: 768px){

    }
  }
  
  .pb-title {
    margin: 1rem 0 1.75rem;
  }

  .image {
    img {
      object-fit: cover;
    }
  }
  
  @media screen and (max-width:1290px) and (min-width: 1022px){
  }
  
  @media screen and (max-width:1023px) {

    .container {
      margin-top: 0 !important;
    }
  
  }
  
  @media screen and (max-width:893px){
  
  }
  
  @media screen and (max-width:768px){
  
  }
  </style>
  